import line from "./line"
import fetchGradients from "~/components/circuit/fetchGradients"
import Tiles from "~/components/tiles"
import { Spinner } from "evergreen-ui"
import { max, flatten } from "lodash"
import { scaleLinear } from "d3-scale"

export default class Weights2 extends Component {
  state = { weights: null }

  componentWillMount() {
    fetchGradients("inceptionv1", "mixed3a", "mixed3b").then(weights => {
      this.setState({ weights })
    })
  }

  render() {
    const { weights } = this.state

    if (!weights) {
      return <Spinner />
    }

    const ZoomedImg = ({ src, size, padding, style, ...props }) => (
      <div
        style={Object.assign({}, style, {
          width: size,
          height: size,
          overflow: "hidden",
          borderRadius: 5,
          position: "relative",
        })}
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{ position: "absolute", left: -padding, top: -padding }}
        />
      </div>
    )

    const size = 90
    const top = 35
    const row = (upstreamNeuron, neuron) => (
      <Surface position="relative">
        <Surface position="absolute" left={50} top={top}>
          <ZoomedImg
            size={size}
            padding={40}
            src={neuronFeatureVis("inceptionv1", "mixed3a", upstreamNeuron)}
          />
        </Surface>
        {line}
        <Surface
          position="absolute"
          left={200}
          top={top}
          borderRadius={5}
          style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
          overflow="hidden"
        >
          <Tiles
            size={size}
            hasBorder={false}
            scale={scaleLinear().domain([
              0,
              35,
              // max(flatten(weights[upstreamNeuron][neuron])),
            ])}
            grad={weights[upstreamNeuron][neuron]}
          />
        </Surface>

        <Surface position="absolute" right={40} top={top}>
          <img
            src={neuronFeatureVis("inceptionv1", "mixed3b", neuron)}
            style={{ borderRadius: 5 }}
            width={90}
            height={90}
          />
        </Surface>
      </Surface>
    )

    const Annotate = ({ children, x, y, size = 40 }) => (
      <Surface position="relative">
        <Surface
          width={size}
          borderRadius={size}
          height={size}
          left={x}
          top={y}
          zIndex={1000}
          position="absolute"
          style={{ border: "2px solid rgba(0, 0, 0, 0.6)" }}
        />
        {children}
      </Surface>
    )

    return (
      <Surface alignItems="center" marginY={40}>
        <Surface flexFlow="row">
          <Surface>
            <Text alignSelf="center" textAlign="center" size={600} width={360}>
              Curves are excited by <b>perpendicular angles</b> facing inward or
              outward
            </Text>
            {row(77, 379)}
            {row(100, 379)}
          </Surface>
          <Surface>
            <Text alignSelf="center" textAlign="center" size={600} width={250}>
              They are inhibited by angles at <b>similar orientations</b>
            </Text>
            {row(149, 330)}
            {row(116, 379)}
          </Surface>
        </Surface>
      </Surface>
    )
  }
}
